
// vuex 추천 강좌 : https://joshua1988.github.io/web-development/vuejs/vuex-start/
import VueCookie from 'vue-cookie';
import axios from 'axios'  // https://github.com/axios/axios
import jwtDecode from 'jwt-decode';
import _config from '../plugins/config'

const state = { // this.$store.state.session.user.name  { "id": "limje", "name": "임지은", "no": "50600", "permiss": "M10300", "iat": 1565056298, "exp": 1565058098 }
  sessionDebug: false,
  lastTokenResponseTime: 0, // (PC기준) 마지막으로 서버에서 수신한 token 시간 (로컬기준)
  lastTokenRequestTime: 0, // (PC기준) 마지막으로 서버로 요청한 토큰 refresh 시간 ( 3초 이내 중복 요청 방지 )
  tokenTimeDiff: 0, // 로컬pc 시간하고 서버 시간하고 차이
  token: null,
  user: {}, // 이렇게 접근 가능 : this.$store.state.session.user
                                 // this.$store.state.session.user = 'accplus'
                                 // 물론 가능하다는 것이지 실제로는 이렇게 하면 안된다.
                                 // ( 내부적으로만 사용 )
    // iat, exp
}

// getters : 값 가져오기
// -- this.$store.getters.user
/*
  import { mapGetters } from 'vuex'                   // mapGetters 를 이용해서 간단하게 vue 와 결합
  computed: { ...mapGetters([ 'user' ]) },            // this.$store.state.user 와 같음
  computed: { ...mapGetters({ userName : 'user' }) }, // 위와 같은데 내부 변수를 userName 으로 설정함 ( vuex 는 'user')
*/
const getters = {
  user      : state => state.user, // this.$store.getters["session/user"] // { "id": "limje", "name": "임지은", "no": "50600", "permiss": "M10300", "iat": 1565056298, "exp": 1565058098 }
  userInfo  : state => `${ state.user.id } ${ state.user.name } iat=${ state.user.iat } exp=${ state.user.exp }`,
  userDpName : state => `${ state.user.name }(${ state.user.membno })`,
  token     : state => state.token,
  isLogin   : state => !!state.token, // this.$store.getters["session/isLogin"]
  // loginInfo : state => 'login info=' + state.user,
}

// mutations : setters 같은 개념으로 동기방식으로 값 설정할때 사용
// -- this.$store.commit("session.SET_USER", user)
/*
  import { mapMutations } from 'vuex'
  methods: { ...mapMutations([ 'SET_USER' ]) }
  methods: { ...mapMutations({ setUser: 'SET_USER'} }
*/
const mutations = {
  set_lastTokenRequestTime : (state,t) => state.lastTokenRequestTime = t,
  SET_TOKEN_FROM_COOKIE : (state,v) => { // 쿠키로부터 토큰을 읽어본다. 이거 실행후 강제 refresh 실행 필요

    const token = VueCookie.get(_config.AUTH_TOKEN_NAME)
    const tokents = VueCookie.get(_config.AUTH_TOKENTS_NAME)

    state.sessionDebug && console.log("[SESSION] session.js SET_TOKEN_FROM_COOKIE - 쿠키에서 인증정보 읽기, token = ", token, "tokents = ", tokents);

    state.sessionDebug && console.log("[SESSION] 쿠키 토큰 재확인 info :", { tokents, token} )

    if (token && tokents) { // 읽어진다면 셋팅
      state.token = token
      state.user = jwtDecode(token)
      state.lastTokenResponseTime = tokents
      state.tokenTimeDiff = Math.floor(state.lastTokenResponseTime / 1000 - state.user.iat)
      state.sessionDebug && console.log("[SESSION] session.js SET_TOKEN_FROM_COOKIE - state.lastTokenResponseTime 설정 = ", state.lastTokenResponseTime);
      state.sessionDebug && console.log("[SESSION] session.js SET_TOKEN_FROM_COOKIE - 쿠키에서 인증정보 읽기 : 완료");

    } else {
      console.log("[JWT] 001 쿠키에 인증정보가 없습니다. ", v)
    }
  },
  SET_TOKEN : (state, token) => {

    state.sessionDebug && console.log("[SESSION] session.js SET_TOKEN - token 설정 실행!");

    state.token = token
    if (token) {
      state.user = jwtDecode(token)
      state.lastTokenResponseTime = new Date().getTime()
      state.tokenTimeDiff = Math.floor(state.lastTokenResponseTime / 1000 - state.user.iat)
      state.sessionDebug && console.log("[SESSION] session.js SET_TOKEN - state.lastTokenResponseTime 설정 = ", state.lastTokenResponseTime);
      // VueCookie.set(_config.AUTH_TOKEN_NAME, token, { expires: '40m' })
      VueCookie.set(_config.AUTH_TOKEN_NAME, token)
      // VueCookie.set(_config.AUTH_TOKENTS_NAME, state.lastTokenResponseTime, { expires: '40m' })
      VueCookie.set(_config.AUTH_TOKENTS_NAME, state.lastTokenResponseTime)
      axios.defaults.headers.common[_config.AUTH_TOKEN_NAME] = token
      // console.log("token 셋팅z : ", "user", state.user, "token", token)

    } else {
      console.log("[JWT] 002 쿠키를 삭제합니다. 002 token = " + token)
      state.user = {}
      state.lastTokenResponseTime = 0
      state.tokenTimeDiff = 0
      state.sessionDebug && console.log("[SESSION] session.js SET_TOKEN - state.lastTokenResponseTime 설정 = ", state.lastTokenResponseTime);
      VueCookie.delete(_config.AUTH_TOKEN_NAME)
      VueCookie.delete(_config.AUTH_TOKENTS_NAME)
      delete axios.defaults.headers.common[_config.AUTH_TOKEN_NAME]
      state.sessionDebug && console.log("token 클리어")
    }
  },
}


const TOKEN_NO_REFRESH_DEFAULT_LIMIT_SEC = 30
const TOKEN_NO_REFRESH_USER_LIMIT_SEC = 3 // 사용자가 연장 요청 클릭시


// actions : 매서드 같은 개념으로 값 설정 또는 기능을 구현할때 사용. 비동기 방식이 가능함
// -- this.$store.dispatch('LOGGED_IN', { user: 'accplus', token: 'xdoiwjfowiejf'});
/*
  import {mapActions} from 'vuex';
  methods: {...mapActions(['LOGGED_IN']) }
  methods: {...mapActions({ doLogin: 'LOGGED_IN'} }
*/
 const actions = {
  // LOGGED_IN (context, payload) { // 로그인 처리 :: this.$store.dispatch('LOGGED_IN', { user: 'accplus', token: 'xdoiwjfowiejf'});
  //   context.commit('SET_TOKEN', payload.token)
  //   // VueCookie.set('token', payload.token, { expires: '40m' })

  //   // VueCookie.get('user');
  // },
  LOGGED_OUT ({ commit }) {
    commit('SET_TOKEN', null)
    VueCookie.delete(_config.AUTH_TOKEN_NAME)
    VueCookie.delete(_config.AUTH_TOKENTS_NAME)
    delete axios.defaults.headers.common[_config.AUTH_TOKEN_NAME]
  },
  TOKEN_REFRESH(context, payload) {

    const refreshType = payload && payload.refreshType || '' // refreshType : force, user
    const now = new Date().getTime()

    state.sessionDebug && console.log(`[SESSION] session.js TOKEN_REFRESH - 요청 refreshType = ${ refreshType}`);

    if (refreshType == 'force') {
      state.sessionDebug && console.log(`[SESSION] session.js TOKEN_REFRESH - 접수 : 무조건 서버 refresh 요청`);

    } else if (this.state.token) {

      const limitSec = refreshType == 'user' ? TOKEN_NO_REFRESH_USER_LIMIT_SEC : TOKEN_NO_REFRESH_DEFAULT_LIMIT_SEC

      // 마지막 응답받고 limitSec 시간 이내 자동 재요청 금지
      const diff = Math.round((now - this.state.lastTokenResponseTime)/1000)
      if (diff < limitSec) {
        state.sessionDebug && console.log(`[SESSION] session.js TOKEN_REFRESH - 거부 : 마지막 refresh 후 ${ limitSec } 초 이내. refresh 하지 않음.( 현재 ${ diff } 초 경과)`);
        return
      } else {
        state.sessionDebug && console.log(`[SESSION] session.js TOKEN_REFRESH - 접수 : 마지막 refresh 후 ${ diff } 초 경과함. 서버로 token refresh 요청`);
      }
    }

    const lastDiff = now - context.state.lastTokenRequestTime
    state.sessionDebug && console.log(`[SESSION] session.js TOKEN_REFRESH - 마지막 요청후 경과시간(ms) = ${ lastDiff }`);

    // 짧은시간 연속요청 금지
    if (lastDiff <= 3000) {
      state.sessionDebug && console.log(`[SESSION] session.js TOKEN_REFRESH - 거부 : 마지막 refresh 요청 이후 3초 이내 재 요청은 무시`);
      return
    }

    state.sessionDebug && console.log(`[SESSION] session.js TOKEN_REFRESH - 실행 = ${ lastDiff }`);
    context.commit("set_lastTokenRequestTime", now)
    axios.get('/front/api/auth/refresh?_r=' + Math.random())
    // 굳이 여기서 .then 처리를 하지 않아도
    // main.js 의 axios.interceptors.response 에서 처리됨.

      // .then(res => {
      //   console.log("[REFRES] res.data", res.data);

      //   if (res && res.headers && res.headers.token) {
      //     const token = res.headers.token
      //     // console.log("jwt 파싱2", jwtDecode(token));
      //     this.commit('SET_TOKEN' , token)
      //     // VueCookie.set('token', token, { expires: '40m' })
      //     // axios.defaults.headers.common.Authorization = token
      //     axios.defaults.headers.common.token = token
      //   }

      // })
  },
}

export default {
  namespaced: true,
  state,     // $store.state.session.user.no
  getters,   // $store.getters["session/user"].no
  mutations, // $store.commit("session.SET_USER", user)
  actions,   // $store.dispatch("session.LOGGED_OUT")
}
